import { useMemo } from 'react';

import { isToolExcludedFromSuggestedPersonas } from 'src/data/generationTool';
import { createStateSelectorHook } from 'src/lib/sweetState';
import { CustomerPersonaStore } from 'src/store';
import { DocumentViewStore } from 'src/views/ProjectDocumentView/store';

import { LocalStore } from '../../store';

const useCustomerPersonaState = createStateSelectorHook(CustomerPersonaStore, [
  'suggestedCustomerPersonas',
  'suggestedCustomerPersonasSeenIds',
  'loadingSuggestedCustomerPersonas',
]);

const useLocalState = createStateSelectorHook(LocalStore, [
  'selectedCustomerPersona',
  'isManagePersonasPopupOpen',
]);

const useDocumentViewStore = createStateSelectorHook(DocumentViewStore, [
  'hasHiddenSuggestedPersonas',
]);

export const useViewState = () => {
  const customerPersonasState = useCustomerPersonaState();
  const localState = useLocalState();
  const documentViewStore = useDocumentViewStore();

  const suggestedCustomerPersonas = useMemo(
    () =>
      isToolExcludedFromSuggestedPersonas(localState.generationTool)
        ? []
        : customerPersonasState.suggestedCustomerPersonas,
    [customerPersonasState.suggestedCustomerPersonas, localState.generationTool]
  );

  return {
    ...customerPersonasState,
    ...localState,
    ...documentViewStore,
    suggestedCustomerPersonas,
  };
};
